import { es, enUS, ja } from "date-fns/locale"; 

export let culture = "es-MX"; //culture name

export let locale = es; // locale used by date-fns, which is used by react-datepicker

export let dateFormat = "dd/MMM/yyyy";